import React, {useCallback} from 'react';
import {observer} from "mobx-react-lite";
import intl from "react-intl-universal";
import classNames from "classnames";
import {useRootStore, useUserState} from "@stores/AppStateContext";
import {useCrudServices} from "../../../platform/hooks/useServiceCombinations";

import {SearchIcon} from '../../components/icons/SearchIcon';
import {Button} from '../../components/Button';
import {LoadingHorizontal} from '../../components/LoadingHorizontal';
import {Tooltip} from "../../components/Tooltip"

import {searchContent} from "../../../actions/searchContent";

export interface SearchHeaderProps {
    haveResults: boolean
}

export const SearchHeader = observer(
    (
        {
            haveResults,
        }: SearchHeaderProps
    ) => {
        const rootStore = useRootStore();
        const userState = useUserState();
        const crudServices = useCrudServices();
        const activeWorkspace = rootStore.view.workspace!;
        let text: string;
        let nothingFoundAnywhere = false;
        if (rootStore.search.queryPerformed) {
            if (!haveResults) {
                text = intl.get('search_results.no_results', {searchQuery: rootStore.search.textInput}).d('No results for: <b>{searchQuery}</b>');
                nothingFoundAnywhere = true;
            } else {
                text = intl.get('search_results.search_results').d('Search results');
            }
        } else if (rootStore.search.isSearching) {
            text = intl.get('search_results.search_in_progress').d('Search in progress');
        } else {
            text = intl.get('search_results.search_contents').d('Search for content');
        }

        const onSearchContent = useCallback(async () => {
            searchContent(crudServices, rootStore, userState!);
        }, [activeWorkspace, crudServices, rootStore, userState]);

        const searchOnClick = !rootStore.search.queryPerformed && !rootStore.search.isSearching;
        return (
            <div
                className="sr-header-wrapper"
                onClick={onSearchContent}
            >
                <div
                    className={classNames({
                        'sr-header': true,
                        'sr-call-to-search': searchOnClick,
                        'sr-call-to-empty': nothingFoundAnywhere,
                    })}
                >
                    <SearchIcon size={20} colorOverwritten={true}/>
                    <span className='sr-text title-medium'
                          dangerouslySetInnerHTML={{
                              __html: text,
                          }}
                    />
                    {
                        searchOnClick
                            ? (
                                <Tooltip title={intl.get('tooltip.searchHeader.pressEnter').d("Press Enter to Search Content")} menuPlacement={"block-end"}>
                                    <div>
                                        <Button
                                            style={'solid'}
                                            type={'primary'}
                                            size={'sm'}
                                            onClick={() => {
                                            }}
                                            text={intl.get('search.search').d('Search')}
                                        />
                                    </div>
                                </Tooltip>
                            )
                            : null
                    }
                </div>
                <LoadingHorizontal
                    isVisible={rootStore.search.isSearching}
                />
            </div>
        );
    }
);
